import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { Form as FinalForm } from 'react-final-form';
import isEqual from 'lodash/isEqual';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import * as validators from '../../util/validators';
import { ensureCurrentUser } from '../../util/data';
import {
  isChangeEmailTakenError,
  isChangeEmailWrongPassword,
  isChangePasswordWrongPassword,
  isTooManyEmailVerificationRequestsError,
} from '../../util/errors';
import {
  FieldPhoneNumberInput,
  Form,
  PrimaryButton,
  FieldTextInput,
  CustomRadioButton,
  Modal,
  FieldPassword,
  InlineTextButton,
} from '../../components';

import css from './ContactDetailsForm.module.css';
import { contactAuthOptions } from '../../marketplace-custom-config';
// import { Modal } from '../../components/Modal';

const SHOW_EMAIL_SENT_TIMEOUT = 2000;
const textfield = 'textfield';
const errorTextField = 'errorTextField';
const allowAuth = 'authAllowed';

// const [authYesValue, setAuthYesValue] = useState(true);

class ContactDetailsFormComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showVerificationEmailSentMessage: false,
      showResetPasswordMessage: false,
      authYesValue: false,
      showAuthModal: false,
      showPasswordModal: false,
      step: 0,
      yesAuthModal: false,
    };
    this.emailSentTimeoutId = null;
    this.handleResendVerificationEmail = this.handleResendVerificationEmail.bind(this);
    this.handleResetPassword = this.handleResetPassword.bind(this);
    this.submittedValues = {};
    this.formApi = null;
    this.handleAuthChange = this.handleAuthChange.bind(this);
    this.turnOffAuthChange = this.turnOffAuthChange.bind(this);
    this.handleChangePswdModal = this.handleChangePswdModal.bind(this);
  }
  handleAuthChange(value) {
    this.formApi.change(allowAuth, value);
    //  console.log(allowAuth, value, 73);
    if (value === contactAuthOptions.no.value) {
      this.setState({
        showAuthModal: true,
      });
    } else {
      this.setState({
        yesAuthModal: true,
      });
    }
  }

  handleChangePswdModal = pswrdmodalInfo => {
    return Promise.resolve(this.props.submitPasswordModalValue(pswrdmodalInfo));
    // this.props.submitPasswordModalValue(pswrdmodalInfo);
  };
  CloseAuthModal = () => {
    this.setState({ showAuthModal: false, yesAuthModal: false });
    this.formApi.change(allowAuth, contactAuthOptions.yes.value);
  };

  turnOffAuthChange = value => {
    // console.log(998, value);
    this.props.submitAuthValue(value);

    this.setState({
      showAuthModal: false,
      yesAuthModal: false,
    });
  };

  handleChangePassword = () => {
    // console.log('change clicked');
    this.setState({
      showPasswordModal: true,
    });
  };

  componentWillUnmount() {
    window.clearTimeout(this.emailSentTimeoutId);
  }

  handleResendVerificationEmail() {
    this.setState({ showVerificationEmailSentMessage: true });

    this.props.onResendVerificationEmail().then(() => {
      // show "verification email sent" text for a bit longer.
      this.emailSentTimeoutId = window.setTimeout(() => {
        this.setState({ showVerificationEmailSentMessage: false });
      }, SHOW_EMAIL_SENT_TIMEOUT);
    });
  }

  handleResetPassword() {
    this.setState({ showResetPasswordMessage: true });
    const email = this.props.currentUser.attributes.email;
    this.props.onResetPassword(email);
  }

  render() {
    const {
      onManageDisableScrolling,
      formId,
      authAllowed,
      currentUser,
      onSubmitContactDetails,
      handleSubmit,
      submitAuthValue,
      submitPasswordModalValue,
      isNewPassword,
      onChangePasswordRequest,
      isProvider,
    } = this.props;
    const passwordId = formId ? `${formId}.password` : 'password';
    return (
      <>
        <FinalForm
          {...this.props}
          render={fieldRenderProps => {
            const {
              rootClassName,
              className,
              saveEmailError,
              savePhoneNumberError,
              currentUser,
              changePasswordError,
              formId,
              handleSubmit,
              inProgress,
              intl,
              invalid,
              sendVerificationEmailError,
              sendVerificationEmailInProgress,
              resetPasswordInProgress,
              values,
              authAllowed,
              errors,
              isNewPassword,
              form,
              onManageDisableScrolling,
              onSubmitContactDetails,
            } = fieldRenderProps;
            this.formApi = form;

            const { email, phoneNumber } = values;
            const { password = '' } = values;
            // console.log(165, values);
            const submitInProgress = inProgress;
            const contactAuthOptionsId = formId
              ? `${formId}.contactAuthOptions`
              : 'contactAuthOptions';
            const user = ensureCurrentUser(currentUser);

            if (!user.id) {
              return null;
            }

            const { email: currentEmail, emailVerified, pendingEmail, profile } = user.attributes;

            // email

            // has the email changed
            const emailChanged = currentEmail !== email;

            const emailLabel = intl.formatMessage({
              id: 'ContactDetailsForm.emailLabel',
            });

            const emailPlaceholder = currentEmail || '';

            const emailRequiredMessage = intl.formatMessage({
              id: 'ContactDetailsForm.emailRequired',
            });
            const emailRequired = validators.required(emailRequiredMessage);
            const emailInvalidMessage = intl.formatMessage({
              id: 'ContactDetailsForm.emailInvalid',
            });
            const emailValid = validators.emailFormatValid(emailInvalidMessage);

            const tooManyVerificationRequests = isTooManyEmailVerificationRequestsError(
              sendVerificationEmailError
            );

            const emailTouched = this.submittedValues.email !== values.email;
            const emailTakenErrorText = isChangeEmailTakenError(saveEmailError)
              ? intl.formatMessage({
                  id: 'ContactDetailsForm.emailTakenError',
                })
              : null;

            let resendEmailMessage = null;
            if (tooManyVerificationRequests) {
              resendEmailMessage = (
                <span className={css.tooMany}>
                  <FormattedMessage id="ContactDetailsForm.tooManyVerificationRequests" />
                </span>
              );
            } else if (
              sendVerificationEmailInProgress ||
              this.state.showVerificationEmailSentMessage
            ) {
              resendEmailMessage = (
                <span className={css.emailSent}>
                  <FormattedMessage id="ContactDetailsForm.emailSent" />
                </span>
              );
            } else {
              resendEmailMessage = (
                <span
                  className={css.helperLink}
                  onClick={this.handleResendVerificationEmail}
                  role="button"
                >
                  <FormattedMessage id="ContactDetailsForm.resendEmailVerificationText" />
                </span>
              );
            }

            // Email status info: unverified, verified and pending email (aka changed unverified email)
            let emailVerifiedInfo = null;

            if (emailVerified && !pendingEmail && !emailChanged) {
              // Current email is verified and there's no pending unverified email
              emailVerifiedInfo = (
                <span className={css.emailVerified}>
                  <FormattedMessage id="ContactDetailsForm.emailVerified" />
                </span>
              );
            } else if (!emailVerified && !pendingEmail) {
              // Current email is unverified. This is the email given in sign up form

              emailVerifiedInfo = (
                <span className={css.emailUnverified}>
                  <FormattedMessage
                    id="ContactDetailsForm.emailUnverified"
                    values={{ resendEmailMessage }}
                  />
                </span>
              );
            } else if (pendingEmail) {
              // Current email has been tried to change, but the new address is not yet verified

              const pendingEmailStyled = <span className={css.emailStyle}>{pendingEmail}</span>;
              const pendingEmailCheckInbox = (
                <span className={css.checkInbox}>
                  <FormattedMessage
                    id="ContactDetailsForm.pendingEmailCheckInbox"
                    values={{ pendingEmail: pendingEmailStyled }}
                  />
                </span>
              );

              emailVerifiedInfo = (
                <span className={css.pendingEmailUnverified}>
                  <FormattedMessage
                    id="ContactDetailsForm.pendingEmailUnverified"
                    values={{
                      pendingEmailCheckInbox,
                      resendEmailMessage,
                    }}
                  />
                </span>
              );
            }

            // phone
            const protectedData = profile.protectedData || {};

            const currentPhoneNumber = protectedData.phoneNumber;

            //is social sign up

            const isSocialSignup = protectedData.isSocialSignup;
            // console.log(163, isSocialSignup);

            // has the phone number changed
            const phoneNumberChanged = currentPhoneNumber !== phoneNumber;

            const phonePlaceholder = intl.formatMessage({
              id: 'ContactDetailsForm.phonePlaceholder',
            });
            const phoneLabel = intl.formatMessage({
              id: 'ContactDetailsForm.phoneLabel',
            });

            // password
            // const passwordLabel = intl.formatMessage({
            //   id: 'ContactDetailsForm.CurrentPasswordLabel',
            // });
            // const passwordPlaceholder = intl.formatMessage({
            //   id: 'ContactDetailsForm.CurrentPasswordPlaceholder',
            // });

            // Current Password

            const CurrentPasswordLabel = intl.formatMessage({
              id: 'ContactDetailsForm.CurrentPasswordLabel',
            });

            const CurrentPasswordPlaceholder = intl.formatMessage({
              id: 'ContactDetailsForm.CurrentPasswordPlaceholder',
            });
            const CurrentPasswordRequiredMessage = intl.formatMessage({
              id: 'ContactDetailsForm.passwordRequired',
            });

            const CurrentPasswordRequired = validators.requiredStringNoTrim(
              CurrentPasswordRequiredMessage
            );

            const CurrentPasswordMinLengthMessage = intl.formatMessage(
              {
                id: 'ContactDetailsForm.passwordTooShort',
              },
              {
                minLength: validators.PASSWORD_MIN_LENGTH,
              }
            );

            const CurrentPasswordMinLength = validators.minLength(
              CurrentPasswordMinLengthMessage,
              validators.PASSWORD_MIN_LENGTH
            );

            const CurrentPasswordValidators = validators.composeValidators(
              CurrentPasswordRequired,
              CurrentPasswordMinLength
            );

            const CurrentPasswordFailedMessage = intl.formatMessage({
              id: 'ContactDetailsForm.passwordFailed',
            });
            // const CurrentPasswordTouched = this.submittedValues.password !== values.password;
            const CurrentPasswordTouched =
              this.submittedValues.currentPassword !== values.currentPassword;

            // console.log(351, 'CurrentPasswordTouched', CurrentPasswordTouched);

            const CurrentPasswordErrorText = isChangePasswordWrongPassword(changePasswordError)
              ? CurrentPasswordFailedMessage
              : null;
            // console.log(353, changePasswordError);

            const CurrentPasswordClasses = classNames(css.confirmChangesSection, {
              [css.confirmChangesSectionVisible]: emailChanged,
            });

            // Confirm New Password

            const ConfirmNewPasswordLabel = intl.formatMessage({
              id: 'ContactDetailsForm.ConfirmNewPasswordLabel',
            });

            const ConfirmNewPasswordPlaceholder = intl.formatMessage({
              id: 'ContactDetailsForm.ConfirmNewPasswordPlaceholder',
            });
            const ConfirmNewPasswordRequiredMessage = intl.formatMessage({
              id: 'ContactDetailsForm.passwordRequired',
            });

            const passwordNotEqualConfirmMessage = intl.formatMessage({
              id: 'ContactDetailsForm.confirmNewPasswordNotEqual',
            });
            const ConfirmPasswordRequired = validators.requiredStringNoTrim(
              ConfirmNewPasswordRequiredMessage
            );

            const confirmPasswordMinLengthMessage = intl.formatMessage(
              {
                id: 'ContactDetailsForm.passwordTooShort',
              },
              {
                minLength: validators.PASSWORD_MIN_LENGTH,
              }
            );

            const confirmPasswordMaxLengthMessage = intl.formatMessage(
              {
                id: 'PasswordResetForm.passwordTooLong',
              },
              {
                maxLength: validators.PASSWORD_MAX_LENGTH,
              }
            );
            const confirmPasswordMinLength = validators.minLength(
              confirmPasswordMinLengthMessage,
              validators.PASSWORD_MIN_LENGTH
            );
            const confirmPasswordMaxLength = validators.maxLength(
              confirmPasswordMaxLengthMessage,
              validators.PASSWORD_MAX_LENGTH
            );

            const isConfirmPasswordEqualPassword = validators.isEqual(
              passwordNotEqualConfirmMessage,
              password
            );

            // const confirmPasswordValidators = emailChanged
            //   ? validators.composeValidators(
            //       ConfirmPasswordRequired,
            //     confirmPasswordMinLength,
            //       confirmPasswordMaxLength,
            //       isConfirmPasswordEqualPassword
            //     )
            //   : null;
            const confirmPasswordValidators = validators.composeValidators(
              ConfirmPasswordRequired,
              confirmPasswordMinLength,
              confirmPasswordMaxLength,
              isConfirmPasswordEqualPassword
            );

            const confirmPasswordFailedMessage = intl.formatMessage({
              id: 'ContactDetailsForm.passwordFailed',
            });
            // const confirmPasswordTouched = this.submittedValues.confirmPassword !== values.password;
            const confirmPasswordTouched = values.confirmPassword !== values.password;
            // console.log(406, 'confirmPasswordTouched', confirmPasswordTouched);
            const confirmPasswordErrorText = isChangePasswordWrongPassword(changePasswordError)
              ? confirmPasswordFailedMessage
              : null;

            const confirmPasswordClasses = classNames(css.confirmChangesSection, {
              [css.confirmChangesSectionVisible]: emailChanged,
            });

            // New Password

            const newPasswordLabel = intl.formatMessage({
              id: 'ContactDetailsForm.newPasswordLabel',
            });

            const newpasswordPlaceholder = intl.formatMessage({
              id: 'ContactDetailsForm.newpasswordPlaceholder',
            });
            const newPasswordRequiredMessage = intl.formatMessage({
              id: 'ContactDetailsForm.passwordRequired',
            });
            const newPasswordRegexRequiredMessage = intl.formatMessage({
              id: 'SignupForm.passwordRegexRequired',
            });
            const passwordRegexRequired = validators.validatePasswordRegex(
              newPasswordRegexRequiredMessage
            );

            const newPasswordRequired = validators.requiredStringNoTrim(newPasswordRequiredMessage);

            const passwordMinLengthMessage = intl.formatMessage(
              {
                id: 'ContactDetailsForm.passwordTooShort',
              },
              {
                minLength: validators.PASSWORD_MIN_LENGTH,
              }
            );
            const passwordMaxLengthMessage = intl.formatMessage(
              {
                id: 'PasswordResetForm.passwordTooLong',
              },
              {
                maxLength: validators.PASSWORD_MAX_LENGTH,
              }
            );

            const passwordMinLength = validators.minLength(
              passwordMinLengthMessage,
              validators.PASSWORD_MIN_LENGTH
            );
            const passwordMaxLength = validators.maxLength(
              passwordMaxLengthMessage,
              validators.PASSWORD_MAX_LENGTH
            );

            const passwordValidators = validators.composeValidators(
              newPasswordRequired,
              passwordMinLength,
              passwordRegexRequired,
              passwordMaxLength
            );

            const passwordFailedMessage = intl.formatMessage({
              id: 'ContactDetailsForm.passwordFailed',
            });
            // const passwordTouched = this.submittedValues.currentPassword !== values.currentPassword;
            const passwordTouched = this.submittedValues.password !== values.password;
            // console.log(238, passwordTouched);
            // const passwordErrorText = isChangePasswordWrongPassword(changePasswordError)
            //   ? passwordFailedMessage
            //   : null;

            const confirmClasses = classNames(css.confirmChangesSection, {
              [css.confirmChangesSectionVisible]: emailChanged,
            });

            // generic error
            const isGenericEmailError =
              saveEmailError && !(emailTakenErrorText || passwordErrorText);

            let genericError = null;

            if (isGenericEmailError && savePhoneNumberError) {
              genericError = (
                <span className={css.error}>
                  <FormattedMessage id="ContactDetailsForm.genericFailure" />
                </span>
              );
            } else if (isGenericEmailError) {
              genericError = (
                <span className={css.error}>
                  <FormattedMessage id="ContactDetailsForm.genericEmailFailure" />
                </span>
              );
            } else if (savePhoneNumberError) {
              genericError = (
                <span className={css.error}>
                  <FormattedMessage id="ContactDetailsForm.genericPhoneNumberFailure" />
                </span>
              );
            }

            const sendPasswordLink = (
              <span className={css.helperLink} onClick={this.handleResetPassword} role="button">
                <FormattedMessage id="ContactDetailsForm.resetPasswordLinkText" />
              </span>
            );

            const resendPasswordLink = (
              <span className={css.helperLink} onClick={this.handleResetPassword} role="button">
                <FormattedMessage id="ContactDetailsForm.resendPasswordLinkText" />
              </span>
            );

            const resetPasswordLink =
              this.state.showResetPasswordMessage || resetPasswordInProgress ? (
                <>
                  <FormattedMessage
                    id="ContactDetailsForm.resetPasswordLinkSent"
                    values={{
                      email: <span className={css.emailStyle}>{currentUser.attributes.email}</span>,
                    }}
                  />{' '}
                  {resendPasswordLink}
                </>
              ) : (
                sendPasswordLink
              );

            const classes = classNames(rootClassName || css.root, className);
            const submittedOnce = Object.keys(this.submittedValues).length > 0;
            const pristineSinceLastSubmit = submittedOnce && isEqual(values, this.submittedValues);

            // const submitDisabled =
            //   invalid ||
            //   pristineSinceLastSubmit ||
            //   inProgress ||
            //   !(emailChanged || phoneNumberChanged);

            const submitDisabled = invalid || submitInProgress;
            // console.log(6788, changePasswordError);
            return (
              <Form
                className={classes}
                // onSubmit={e => {
                //   this.submittedValues = values;
                //   handleSubmit(e);
                // }}
              >
                {/* <div className={css.contactDetailsSection}>
                <FieldTextInput
                  type="email"
                  name="email"
                  id={formId ? `${formId}.email` : 'email'}
                  label={emailLabel}
                  placeholder={emailPlaceholder}
                  validate={validators.composeValidators(emailRequired, emailValid)}
                  customErrorText={emailTouched ? null : emailTakenErrorText}
                />
                {emailVerifiedInfo}
                <FieldPhoneNumberInput
                  className={css.phone}
                  name="phoneNumber"
                  id={formId ? `${formId}.phoneNumber` : 'phoneNumber'}
                  label={phoneLabel}
                  placeholder={phonePlaceholder}
                />
              </div>

              <div className={confirmClasses}>
                <h3 className={css.confirmChangesTitle}>
                  <FormattedMessage id="ContactDetailsForm.confirmChangesTitle" />
                </h3>
                <p className={css.confirmChangesInfo}>
                  <FormattedMessage id="ContactDetailsForm.confirmChangesInfo" />
                  <br />
                  <FormattedMessage
                    id="ContactDetailsForm.resetPasswordInfo"
                    values={{ resetPasswordLink }}
                  />
                </p>

                <FieldTextInput
                  className={css.password}
                  type="password"
                  name="currentPassword"
                  id={formId ? `${formId}.currentPassword` : 'currentPassword'}
                  autoComplete="current-password"
                  label={passwordLabel}
                  placeholder={passwordPlaceholder}
                  validate={passwordValidators}
                  customErrorText={passwordTouched ? null : passwordErrorText}
                />
              </div>
              <div className={css.bottomWrapper}>
                {genericError}
                <PrimaryButton
                  type="submit"
                  inProgress={inProgress}
                  ready={pristineSinceLastSubmit}
                  disabled={submitDisabled}
                >
                  <FormattedMessage id="ContactDetailsForm.saveChanges" />
                </PrimaryButton>
              </div> */}

                <div className={css.ContactDetailsTwoFactorAuth}>
                  <span className={css.ContactDetailsTwoFactorAuthText}>
                    <FormattedMessage id="ContactDetailsForm.TwoFactorAuthText" />
                  </span>

                  <CustomRadioButton
                    name={allowAuth}
                    onChange={this.handleAuthChange}
                    radioValues={Object.values(contactAuthOptions)}
                    id={contactAuthOptionsId}
                    withForm={false}
                    formClassName={css.option}
                    values={values}
                    radioSelectedInputClassName={classNames({
                      [css.notAllowedOption]: values[allowAuth] === contactAuthOptions.no.value,
                    })}
                  />
                </div>

                {!isSocialSignup ? (
                  <div className={css.changePasswordDiv}>
                    <span className={css.changePswdText} onClick={this.handleChangePassword}>
                      {' '}
                      <FormattedMessage id="ContactDetailsFrom.changePswdText" />
                    </span>
                  </div>
                ) : null}

                <Modal
                  className={css.YesAuthModal}
                  id="ContactDetails.yesAuthModal"
                  isOpen={this.state.yesAuthModal}
                  onClose={this.CloseAuthModal}
                  scrollLayerClassName={css.modalScrollLayer}
                  containerClassName={css.modalContainer}
                  contentClassName={css.modalContent}
                  onManageDisableScrolling={onManageDisableScrolling}
                  usePortal
                  showCloseButton={false}
                >
                  <div className={css.authTextContainer}>
                    <div className={css.authHeading}>
                      <FormattedMessage id="ContactDetailsForm.TurnOnAuthHeading" />
                    </div>

                    <div className={css.authDesc}>
                      <p className={css.authDescPara1}>
                        <FormattedMessage id="ContactDetailsForm.TurnOnAuthDescPara1" />
                      </p>
                      <p className={css.authDescPara1}>
                        <FormattedMessage id="ContactDetailsForm.TurnOnAuthDescPara2" />
                      </p>
                    </div>
                    <button
                      className={css.turnOffAuthBtn}
                      onClick={() => {
                        this.turnOffAuthChange(values);
                      }}
                    >
                      {' '}
                      <FormattedMessage id="ContactDetailsForm.TurnOnAuth" />{' '}
                    </button>
                  </div>
                </Modal>

                <Modal
                  className={css.CloseAuthModal}
                  id="ContactDetails.showAuthModal"
                  isOpen={this.state.showAuthModal}
                  onClose={this.CloseAuthModal}
                  scrollLayerClassName={css.modalScrollLayer}
                  containerClassName={css.modalContainer}
                  contentClassName={css.modalContent}
                  onManageDisableScrolling={onManageDisableScrolling}
                  usePortal
                >
                  <div className={css.authTextContainer}>
                    <div className={css.authHeading}>
                      {' '}
                      <FormattedMessage id="ContactDetailsForm.AuthHeading" />{' '}
                    </div>
                    <div className={css.authDesc}>
                      <p className={css.authDescPara1}>
                        <FormattedMessage id="ContactDetailsForm.authDescPara1" />
                      </p>
                      <p className={css.authDescPara1}>
                        <FormattedMessage id="ContactDetailsForm.authDescPara2" />
                      </p>
                    </div>

                    <button
                      className={css.turnOffAuthBtn}
                      onClick={() => {
                        this.turnOffAuthChange(values);
                      }}
                    >
                      {' '}
                      <FormattedMessage id="ContactDetailsForm.AuthHeading" />{' '}
                    </button>
                  </div>
                </Modal>

                {/* New password Modal */}
                <div>
                  <Modal
                    className={css.showPasswordModal}
                    id="ContactDetails.showPasswordModal"
                    isOpen={this.state.showPasswordModal}
                    onClose={() => this.setState({ showPasswordModal: false })}
                    scrollLayerClassName={css.modalScrollLayer}
                    containerClassName={css.modalContainer}
                    // containerClassName={css.showPasswordModal}
                    contentClassName={css.modalContent}
                    onManageDisableScrolling={onManageDisableScrolling}
                    usePortal
                  >
                    <div className={css.changePasswordModal}>
                      <h3 className={css.confirmChangesTitle}>
                        <FormattedMessage id="ContactDetailsForm.ChangePaswdHeading" />{' '}
                      </h3>
                      <div className={css.changePswdField}>
                        <FieldPassword
                          className={classNames(css.password, textfield)}
                          errorClassName={errorTextField}
                          id={passwordId}
                          name="password"
                          // autoComplete="new-password"
                          label={newPasswordLabel}
                          placeholder={newpasswordPlaceholder}
                          validate={passwordValidators}
                          // customErrorText={passwordTouched ? null : passwordErrorText}
                          // passwordCheckRefValues={[fname, lname, email]}
                        />
                        <FieldPassword
                          className={classNames(css.password, textfield)}
                          errorClassName={errorTextField}
                          id={passwordId}
                          // name="password"
                          name="confirmPassword"
                          // autoComplete="new-password"
                          label={ConfirmNewPasswordLabel}
                          placeholder={ConfirmNewPasswordPlaceholder}
                          validate={confirmPasswordValidators}
                          // refValue={password}
                          // customErrorText={confirmPasswordTouched ? null : confirmPasswordErrorText}

                          // passwordCheckRefValues={[fname, lname, email]}
                        />
                      </div>

                      <div className={css.currentPasswordField}>
                        <h3 className={css.confirmChangesTitle}>
                          <FormattedMessage id="ContactDetailsForm.confirmChangesTitle" />
                        </h3>
                        <FieldPassword
                          className={classNames(css.password, textfield)}
                          errorClassName={errorTextField}
                          id={passwordId}
                          name="currentPassword"
                          onChange={e => {
                            onChangePasswordRequest();
                            form.change('currentPassword', e);
                          }}
                          label={CurrentPasswordLabel}
                          placeholder={CurrentPasswordPlaceholder}
                          // validate={CurrentPasswordValidators}
                          customErrorText={CurrentPasswordTouched ? null : CurrentPasswordErrorText}

                          // passwordCheckRefValues={[fname, lname, email]}
                        />
                      </div>

                      <p className={css.confirmChangesInfo}>
                        <FormattedMessage
                          id="ContactDetailsForm.resetPasswordInfo"
                          values={{
                            resetPasswordLink,
                          }}
                        />
                      </p>

                      <div className={css.bottoncontainer}>
                        <PrimaryButton
                          className={css.submitBtn1}
                          type="submit"
                          inProgress={submitInProgress}
                          disabled={submitDisabled}
                          // ready={pristineSinceLastSubmit}
                          onClick={() => {
                            this.submittedValues = values;

                            // form.restart();
                            // console.log(9777, CurrentPasswordTouched);
                            // console.log(changePasswordError, this.state.showPasswordModal,823);
                            // console.log(827, changePasswordError);

                            this.handleChangePswdModal(values).then(res => {
                              if (changePasswordError === null) {
                                this.setState({ showPasswordModal: false });
                                form.restart();
                              } else {
                                this.setState({ showPasswordModal: true });
                              }
                            });
                          }}

                          // onChange={form.reset}
                        >
                          <FormattedMessage id="ContactInformationForm.save" />
                        </PrimaryButton>
                        <InlineTextButton
                          type="button"
                          className={css.cancelBtn}
                          onClick={() => {
                            this.setState({ showPasswordModal: false });
                            form.restart();
                          }}
                        >
                          <FormattedMessage id="SignupForm.Cancel" />
                        </InlineTextButton>
                      </div>
                    </div>
                  </Modal>
                </div>

                {/* <FieldPassword
                  className={classNames(css.password, textfield)}
                  errorClassName={errorTextField}
                  id={passwordId}
                  name="password"
                  // autoComplete="new-password"
                  label={passwordLabel}
                  placeholder={passwordPlaceholder}
                  validate={passwordValidators}
                  // passwordCheckRefValues={[fname, lname, email]}
                /> */}
              </Form>
            );
          }}
        />
        {/* <Modal
          id="ContactDetails.showAuthModal"
          isOpen={this.state.showAuthModal}
          onClose={() => this.setState({ showAuthModal: false })}
          scrollLayerClassName={css.modalScrollLayer}
          containerClassName={css.modalContainer}
          contentClassName={css.modalContent}
          onManageDisableScrolling={onManageDisableScrolling}
          usePortal
        >
          <div className={css.authTextContainer}>
            <div className={css.authHeading}>
              {' '}
              <FormattedMessage id="ContactDetailsForm.AuthHeading" />{' '}
            </div>
            <div className={css.authDesc}>
              <p className={css.authDescPara1}>
                <FormattedMessage id="ContactDetailsForm.authDescPara1" />
              </p>
              <p className={css.authDescPara2}>
                <FormattedMessage id="ContactDetailsForm.authDescPara2" />
              </p>
            </div>

            <button className={css.turnOffAuthBtn} onClick={this.turnOffAuthChange}>
              {' '}
              <FormattedMessage id="ContactDetailsForm.AuthHeading" />{' '}
            </button>
          </div>
        </Modal> */}

        {/*////// change password modal */}

        {/* <Modal
          id="ContactDetails.showPasswordModal"
          isOpen={this.state.showPasswordModal}
          onClose={() => this.setState({ showPasswordModal: false })}
          scrollLayerClassName={css.modalScrollLayer}
          containerClassName={css.modalContainer}
          contentClassName={css.modalContent}
          onManageDisableScrolling={onManageDisableScrolling}
          usePortal
        >
          <span>Change Your Password</span>
          <div className={css.changePswdField}>
            <FieldPassword/>

          </div>
        </Modal> */}
      </>
    );
  }
}

ContactDetailsFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  formId: null,
  saveEmailError: null,
  savePhoneNumberError: null,
  inProgress: false,
  sendVerificationEmailError: null,
  sendVerificationEmailInProgress: false,
  email: null,
  phoneNumber: null,
  resetPasswordInProgress: false,
  resetPasswordError: null,
};

const { bool, func, string } = PropTypes;

ContactDetailsFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  formId: string,
  saveEmailError: propTypes.error,
  savePhoneNumberError: propTypes.error,
  inProgress: bool,
  intl: intlShape.isRequired,
  onResendVerificationEmail: func.isRequired,
  ready: bool.isRequired,
  sendVerificationEmailError: propTypes.error,
  sendVerificationEmailInProgress: bool,
  resetPasswordInProgress: bool,
  resetPasswordError: propTypes.error,
};

const ContactDetailsForm = compose(injectIntl)(ContactDetailsFormComponent);

ContactDetailsForm.displayName = 'ContactDetailsForm';

export default ContactDetailsForm;
